import {Tabs, Tab, Grid} from '@mui/material';
import {useTranslation} from "react-i18next";
import {observer} from 'mobx-react';
import React from 'react';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {TAB_LOCATION, TAB_CITY} from './StatsCommon.js';
import StatsCity from './StatsCity.js';
import StatsAsso from './StatsAsso.js';
import StatsLoc from './StatsLoc.js';

const StatsLocation = observer((props) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	const handleTabChange = (event, tab) => {
		gStorage.stats.setObsList(null);
		gStorage.stats.setLocTab(tab + TAB_CITY);
	}

	if (gStorage.stats.tab !== TAB_LOCATION)
		return null;

	return (
		<>
			<Grid container direction="row" justifyContent="center" spacing={0} columns={1}>
				<Tabs
					id='locationtab'
					value={gStorage.stats.loc_tab - TAB_CITY}
					onChange={handleTabChange} 
					align={'center'}
					indicatorColor="primary"
					textColor="primary"
					scrollButtons="auto"
					variant="scrollable"
					sx={{mb: 1}}>
					<Tab label={t('stats.by_city')} disabled={!gStorage.conn.online}/>
					<Tab label={t('stats.association')} disabled={!gStorage.conn.online}/>
					<Tab label={t('stats.custom_locations')} disabled={!gStorage.conn.online}/>
				</Tabs>
			</Grid>

			<StatsCity />
			<StatsAsso />
			<StatsLoc />
		</>
	);
});

export default StatsLocation;
